import { getApi, postApi } from '../../../utils/api'

export function getTemplates(search, apiParams) {
  const params = { ...(search ? { search } : null) }

  return getApi({
    endpoint: '/api/text-module/email-snippet/',
    params: {
      ...apiParams,
      ...params,
    },
  })
}

export function getTemplate(id, data) {
  return postApi({
    data,
    endpoint: `/api/text-module/email-snippet/${id}/render/`,
  })
}

export function getGoogleConnection() {
  return getApi({ endpoint: '/api/doc-templates/google-connection/' })
}
